<template>
  <div id="app">
    <router-view />
  </div>
</template>

<!--<script>-->
<!--import HelloWorld from './components/HelloWorld.vue'-->

<!--export default {-->
  <!--name: 'app',-->
  <!--activeIndex: '1',-->
  <!--activeIndex2: '1',-->

  <!--components: {-->
    <!--HelloWorld-->
  <!--},-->
  <!--created(){-->
    <!--console.log('app.vue生命周期函数created,dom未生成',this.httpApi)-->
  <!--},-->
  <!--update(){-->
    <!--console.log('app.vue生命周期函数update')-->

  <!--},-->
  <!--mounted(){-->
    <!--console.log('app.vue生命周期函数mounted')-->
  <!--},-->
  <!--handleSelect(){-->

  <!--},-->
  <!--beforeCompile(){-->
    <!--console.log('app.vue生命周期函数beforeCompile')-->
  <!--},-->
<!--}-->
<!--</script>-->

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({

});
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
